<template>
  <div :class="$options.name"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneDropdownSeparator",
  setup() {
    return {};
  },
});
</script>

<style scoped>
@reference "vue-app/assets/scss/main.css";

.EdroneDropdownSeparator {
  width: 100%;
  height: 1px;
  @apply tw:bg-default-200;
}
</style>
